"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.object = exports.bool = exports.number = exports.string = exports.func = void 0;
function func(funcCallback) {
    return {
        handle(key, value) {
            return funcCallback(key, value);
        }
    };
}
exports.func = func;
function string(defaultValue) {
    return func((_, value) => value ?? defaultValue?.());
}
exports.string = string;
function number(defaultValue) {
    return func((_, value) => {
        let num = +value;
        if (isNaN(num)) {
            return defaultValue?.() ?? 0;
        }
        return num;
    });
}
exports.number = number;
function bool() {
    return func((_, value) => {
        let val = false;
        const boolVal = value?.toLowerCase();
        const boolNum = +boolVal;
        if (!isNaN(boolNum)) {
            val = !!boolNum;
        }
        else if (boolVal === 'true') {
            val = true;
        }
        return val;
    });
}
exports.bool = bool;
function object(obj, defaultValue) {
    return func((_, value) => {
        if (value in obj) {
            return obj[value];
        }
        if (defaultValue) {
            return defaultValue();
        }
        return null;
    });
}
exports.object = object;
//# sourceMappingURL=queryStringSchema.js.map